import { render, staticRenderFns } from "./constitution.vue?vue&type=template&id=1c9f0400&scoped=true"
import script from "./constitution.vue?vue&type=script&lang=js"
export * from "./constitution.vue?vue&type=script&lang=js"
import style0 from "./constitution.vue?vue&type=style&index=0&id=1c9f0400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9f0400",
  null
  
)

export default component.exports